import { render, staticRenderFns } from "./EditingContainer.vue?vue&type=template&id=b6e1fbc4&scoped=true&"
import script from "./EditingContainer.vue?vue&type=script&lang=js&"
export * from "./EditingContainer.vue?vue&type=script&lang=js&"
import style0 from "./EditingContainer.vue?vue&type=style&index=0&id=b6e1fbc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6e1fbc4",
  null
  
)

component.options.__file = "EditingContainer.vue"
export default component.exports